
import { TABLEBOOKING } from "../../index";
import axios from "axios";

export const getTableBookingApi = (postData) => {
  return axios.post(TABLEBOOKING, postData);
};
